import { ROSELoader } from './rose';

/**
 * @enum {Number}
 * @readonly
 */
export const LANGUAGE = {
  KOREAN:              0,
  ENGLISH:             1,
  JAPANESE:            2,
  CHINESE_TRADITIONAL: 3,
  CHINESE_SIMPLIFIED:  4
};

/**
 * @enum {Number}
 * @readonly
 */
export const FORMAT = {
  STL_TEXT:    1 << 0,
  STL_COMMENT: 1 << 1,
  STL_QUEST:   1 << 2
};

export class StringTableKey {
  name: string;
  id: number;

  constructor(name: string, id: number) {
    this.name = name;
    this.id = id;
  }
}

export class StringTableEntry {
  text?: string;
  comment?: string;
  quest1?: string;
  quest2?: string;
}

export class StringTable {
  // Static references to enums for backwards compatibility
  static LANGUAGE = LANGUAGE;
  static FORMAT = FORMAT;

  rh: any;
  format: number = 0;
  keys: any = {};
  offsets: any[] = [];
  useLanguage: number = LANGUAGE.ENGLISH;

  constructor(rh: any) {
    this.rh = rh;
  }

  getByKey(key: string): StringTableEntry {
    return this.getById(this.keys[key]);
  }

  getById(id: number): StringTableEntry {
    const entry = new StringTableEntry();
    this.rh.seek(this.offsets[this.useLanguage][id]);

    if (this.format & FORMAT.STL_TEXT) {
      entry.text = this.rh.readVarLengthStr();
    }

    if (this.format & FORMAT.STL_COMMENT) {
      entry.comment = this.rh.readVarLengthStr();
    }

    if (this.format & FORMAT.STL_QUEST) {
      entry.quest1 = this.rh.readVarLengthStr();
      entry.quest2 = this.rh.readVarLengthStr();
    }

    return entry;
  }

  static parse(rh: any): StringTable {
    const data = new StringTable(rh);
    const magic = rh.readVarLengthStr();
    if (magic === 'NRST01') {
      data.format = FORMAT.STL_TEXT;
    } else if (magic === 'ITST01') {
      data.format = FORMAT.STL_TEXT | FORMAT.STL_COMMENT;
    } else if (magic === 'QEST01') {
      data.format = FORMAT.STL_TEXT | FORMAT.STL_COMMENT | FORMAT.STL_QUEST;
    } else {
      throw 'Unsupported STL magic header ' + magic;
    }
    const entries = rh.readUint32();
    for (let i = 0; i < entries; ++i) {
      const name = rh.readVarLengthStr();
      rh.skip(4);
      data.keys[name] = i;
    }
    const languages = rh.readUint32();
    for (let i = 0; i < languages; ++i) {
      const offset = rh.readUint32();
      const pos    = rh.tell();
      rh.seek(offset);
      data.offsets[i] = rh.readUint32Array(entries);
      rh.seek(pos);
    }
    return data;
  }

  static load(path: any, callback: any) {
    ROSELoader.load(path, function(rh: any) {
      callback(StringTable.parse(rh));
    });
  }
}
